export const API_URL =
  process.env.REACT_APP_DEV_API_URL ||
  "https://temple-backend.herokuapp.com/api/v1";

export const SOCKET_API_URL =
  process.env.REACT_APP_SOCKET_URL || "https://temple-backend.herokuapp.com";
